import React, {useContext} from "react";
import GlobalContext from "../context/GlobalContext";
import dayjs from "dayjs";
import CreateEventButton from "./CreateEventButton";

export default function CalendarHeader() {

    const {monthIndex, setMonthIndex} = useContext(GlobalContext);

    const handlerPrevMonth = () => {
        setMonthIndex(monthIndex - 1);
    }

    const handlerNextMonth = () => {
        setMonthIndex(monthIndex + 1);
    }

    const handlerResetMonth = () => {
        setMonthIndex(
            monthIndex === dayjs().month()
                ? monthIndex + Math.random()
                : dayjs().month());
    }
    return (
        <header  className=" py-6 flex ">
            {/*<img src={logo} alt="calendar" className="mr-2 w-20 h-20"/>*/}
            {/* <h1 className="mr-10 text-xl text-gray-500 font-bold">Calendar</h1> */}
            <div className="flex">
                <button className="border rounded-3xl h-10 py-2 px-4 mr-5 mt-2 bg-green-600 hover:bg-green-700 text-white font-bold"
                        onClick={handlerResetMonth}>today
                </button>
                <button onClick={handlerPrevMonth}>
                    <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2">
                        chevron_left
                    </span>
                </button>
                <button onClick={handlerNextMonth}>
                    <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2">
                        chevron_right
                    </span>
                </button>
                <h2 className="ml-4 text-xl mt-3 text-gray-500 font-bold">
                    {dayjs(new Date(dayjs().year(), monthIndex)).format("MMMM YYYY")}
                </h2>
            </div>
            <div className="md:container md:-mx-50 sm:container   lg:container lg:mx-end">
                <CreateEventButton/>
            </div>
        </header>
    );
}